import React from "react"
import { Redirect, Route, Switch } from "react-router-dom"

import BottomNav from "./components/BottomNav"
import MobileHome from "./pages/MobileHome"
import MobileMore from "./pages/MobileMore"
import MobileSection from "./pages/MobileSection"
import useMobileSections from "./useMobileSections"

import "./mobile.less"

/**
 * Mobil ilova qobig'i.
 *
 * Web tizimning o'z tuzilmasidan alohida turadi: o'zining sarlavhasi va
 * pastki menyusi bor, chap panel va boshqa og'ir qismlar yuklanmaydi.
 * Shuning uchun telefonda tez ochiladi.
 *
 * Ma'lumot manbai o'zgarmagan — xuddi shu so'rovlar ishlatiladi, ya'ni
 * raqamlar web tizimdagi bilan bir xil bo'ladi.
 */
export default function MobileApp() {
  const { tabs } = useMobileSections()

  return (
    <div className="mb-app">
      <Switch>
        <Route exact path="/m" component={MobileHome} />
        <Route exact path="/m/more" component={MobileMore} />
        <Route exact path="/m/:code" component={MobileSection} />
        <Redirect to="/m" />
      </Switch>

      <BottomNav tabs={tabs} />
    </div>
  )
}
